/**
 * Created by mcochrane on 25/08/17.
 */
var oldOnError = null
var caughtError = null

function replacementOnError (msg, file, line, col, error) {
  caughtError = { msg, file, line, col, error }
}

function enableCatchWindowErrors () {
  oldOnError = window.onerror
  caughtError = null
  window.onerror = replacementOnError
}

function disableCatchWindowErrors () {
  window.onerror = oldOnError
  if (caughtError) {
    throw caughtError
  }
}

export function addScript (code) {
  let s = document.createElement('script')
  s.text = code
  enableCatchWindowErrors()
  document.body.appendChild(s)
  disableCatchWindowErrors()
  return s
}

export function addCss (code) {
  let s = document.createElement('style')
  s.type = 'text/css'
  s.innerHTML = code
  document.body.appendChild(s)
  return s
}

export function addCssWithSrc (src) {
  let s = document.createElement('style')
  s.type = 'text/css'
  s.setAttribute('src', src)
  document.body.appendChild(s)
  return s
}

export function addScriptWithSrc (src) {
  let s = document.createElement('script')
  s.setAttribute('src', src)
  document.body.appendChild(s)
  return s
}

// 18.2 - 488
export function guid () {
  function s4 () {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }

  return 'name_' + s4() + s4() + '' + s4() + '' + s4() + '' +
    s4() + '' + s4() + s4() + s4()
}

String.prototype.replaceAll = function (search, replacement) { // eslint-disable-line no-extend-native
  let target = this
  return target.replace(new RegExp(search, 'g'), replacement)
}

export function stringDiffLoc (str1, str2) {
  var x
  for (x = 0; x < Math.min(str1.length, str2.length); x++) {
    var c1 = str1.charAt(x)
    var c2 = str2.charAt(x)
    if (c1 !== c2) return x // was != have I broken this by changing to !== ?  I don't think so..
  }
  return x
}
